export const MODULES_SETTINGS = {
  optimizer: {
    title: {
      en: 'Optimizer',
      es: 'Optimizador',
    },
    icon: 'mdi-brain',
    childrenRoutes: [
      'optimizer',
      'group-forecaster',
      'productRecommendation',
      'priceDetailByDemand',
      'menu-recommendation-list',
      'menu-recommendation',
      'menu-recommendation-detail',
    ],
  },
  optimizerPro: {
    title: {
      en: 'Optimizer',
      es: 'Optimizador',
    },
    icon: 'mdi-brain',
    childrenRoutes: [
      'optimizer-pro',
      'group-forecaster-pro',
      'price-manager',
      'menu-manager',
    ],
  },
  manualConfig: {
    title: {
      en: 'Manual Config',
      es: 'Configuración Manual',
    },
    icon: 'mdi-hammer',
    childrenRoutes: [
      'product-boost',
      'manualConfig',
      'sale-rate-indexing-rule',
      'demand-indexing-rule',
      'product-indexing',
      'product-recommendation',
      'menu-initial-recommendation',
      'menu-banner-recommendation'
    ],
  },
  menuEditor: {
    title: {
      en: 'Menu Editor',
      es: 'Editor de menús',
    },
    icon: 'fa-edit',
    childrenRoutes: [
      'menuList',
      'menuEditor',
      'sectionEditor',
    ],
  },
  reporting: {
    title: {
      en: 'Reporting',
      es: 'Informes',
    },
    icon: 'fa-chart-line',
    childrenRoutes: ['reporting'],
  },
  masters: {
    title: {
      en: 'Master Data',
      es: 'Gestion de Maestros',
    },
    icon: 'mdi-barcode-scan',
    childrenRoutes: [
      'masters',
      'product',
      'saleZone'
    ],
  },
  powerBiReporting: {
    title: {
      en: 'Reporting BI',
      es: 'Informes BI',
    },
    icon: 'fa-chart-line',
    childrenRoutes: ['power-bi-reporting'],
  },
};
